import request from 'superagent';
import superagentPromisePlugin from 'superagent-promise-plugin';
import {config, HEADER_STORE_CODE} from '../config/config';
import moment from 'moment';
import {ServerActions} from '../data/Action';
import authUtils from '../script/utils/commons';

const now = Date.now();

function getMock(mockDelay) {

    if (!mockDelay) {
        mockDelay = 500;
    }

    return new Promise(resolve => {
        setTimeout(() => resolve({
            id: 106,
            name: 'PH BOAVISTA',
            lat: 41.155223,
            lng: -8.630050,
            avgPreparationTime: (7.399 + Math.random() * 3) * 60,
            avgDispatchTime: (3 + Math.random() * 3) * 60,
            avgStoreTime: (7.399 + Math.random() * 3) * 60,
            avgDrivingTime: (15.299 + Math.random() * 3) * 60,
            avgDeliveryTime: (22.689 + Math.random() * 3) * 60,
            expectedDeliveryTime: (30 + Math.ceil(Math.random() * 5) * 5),
            avgRating: (Math.random() * 4) + 1,
            drivers: [{
                id: 29,
                name: 'André Silva',
                status: 'free',
                coordinates: {lat: 41.155223 + (Math.random() / 500), lng: -8.630050 + (Math.random() / 500)},
                currentRunOrders: 0,
                currentRunClosedOrders: 0,
                updatedAt: moment(now).toISOString(),
            }, {
                id: 28,
                name: 'Tiago Rodrigues',
                status: 'free',
                coordinates: {lat: 41.155223 + (Math.random() / 500), lng: -8.630050 + (Math.random() / 500)},
                updatedAt: moment(now).toISOString(),
            }, {
                id: 30,
                name: 'Rui',
                status: 'busy',
                coordinates: {lat: 41.1652606 + (Math.random() / 50), lng: -8.6115705 + (Math.random() / 50)},
                currentRunOrders: 2,
                currentRunClosedOrders: 1,
                updatedAt: moment(now).toISOString(),
            }, {
                id: 31,
                name: 'Guilherme',
                status: 'busy',
                updatedAt: moment(now).toISOString(),
                coordinates: {lat: 41.1600606 + (Math.random() / 50), lng: -8.6195705 + (Math.random() / 50)},
                currentRunOrders: 2,
                currentRunClosedOrders: 0,
            }, {
                id: 32,
                name: 'João',
                status: 'busy',
                coordinates: {lat: 41.1562606 + (Math.random() / 50), lng: -8.6015705 + (Math.random() / 50)},
                currentRunOrders: 5,
                currentRunClosedOrders: 2,
                updatedAt: moment(now).toISOString(),
            }, {
                id: 33,
                name: 'Bruno Azevedo',
                status: 'busy',
                coordinates: {lat: 41.1562606 + (Math.random() / 50), lng: -8.6505705 + (Math.random() / 50)},
                currentRunOrders: 5,
                currentRunClosedOrders: 3,
                updatedAt: moment(now).toISOString(),
            }, {
                id: 34,
                name: 'Vasco Pinto',
                status: 'busy',
                coordinates: {lat: 41.1642606 + (Math.random() / 50), lng: -8.6465705 + (Math.random() / 50)},
                currentRunOrders: 5,
                currentRunClosedOrders: 4,
                updatedAt: moment(now).toISOString(),
            }, {
                id: 35,
                name: 'Luis',
                status: 'returning',
                coordinates: {lat: 41.155223 + (Math.random() / 50), lng: -8.631050 + (Math.random() / 50)},
                currentRunOrders: 3,
                currentRunClosedOrders: 3,
                _returningInfo: {duration: Math.trunc(Math.random() * 1000000), distance: 5347},
                updatedAt: moment(now).toISOString()
            }, {
                id: 36,
                name: 'Carlos',
                status: 'returning',
                coordinates: {lat: 41.1452606 + (Math.random() / 50), lng: -8.6015705 + (Math.random() / 50)},
                currentRunOrders: 2,
                currentRunClosedOrders: 2,
                _returningInfo: {duration: Math.trunc(Math.random() * 1000000), distance: 6247},
                updatedAt: moment(now).toISOString()
            }],
            orders: [
                {
                    id: 141771,
                    code: 277,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua Círiaco Cardoso 123 Porto Andar 5 Direito Frente',
                    city: 'PORTO',
                    postalCode: '4150-211 PORTO',
                    addressObs: null,
                    total: 33.45,
                    notes: null,
                    deliveryDate: moment(now + 30 * 60e3).toISOString(),
                    status: 'created',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 27 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 417722,
                    code: 277,
                    customerName: 'DANIEL Martinho',
                    customerPhone: '913081573',
                    address: 'RUA CALOUSTE GULBENKIAN 17 5ºANDAR',
                    city: 'PORTO',
                    postalCode: '4050-145 PORTO',
                    addressObs: null,
                    total: 23.45,
                    notes: null,
                    deliveryDate: moment(now + 35 * 60e3).toISOString(),
                    status: 'created',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 17 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 417733,
                    code: 277,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'R. Feliciano de Castilho 211',
                    city: 'PORTO',
                    postalCode: '4150-312 PORTO',
                    addressObs: null,
                    total: 43.45,
                    notes: null,
                    deliveryDate: moment(now + 40 * 60e3).toISOString(),
                    status: 'created',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 7 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 417744,
                    code: 277,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4000-099 PORTO',
                    addressObs: null,
                    total: 13.45,
                    notes: null,
                    deliveryDate: moment(now + 17 * 60e3).toISOString(),
                    status: 'created',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 37 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 417745,
                    code: 277,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Constituição',
                    city: 'PORTO',
                    postalCode: '4250-162 PORTO',
                    addressObs: null,
                    total: 13.45,
                    notes: null,
                    deliveryDate: moment(now + 19 * 60e3).toISOString(),
                    status: 'created',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 37 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 417746,
                    code: 377,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Quinta Amarela Nº 87',
                    city: 'PORTO',
                    postalCode: '4050-277 PORTO',
                    addressObs: null,
                    total: 13.45,
                    notes: null,
                    deliveryDate: moment(now + 22 * 60e3).toISOString(),
                    status: 'created',
                    rating: null,
                    maximumSpeed: null,
                    returnReason: null,
                    createdAt: moment(now - 37 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
            ],
            alarms: [
                //    {
                //    id: 234567,
                //    driverId: 45422,
                //    driverName: 'Teste Driver',
                //    status: 'OPEN',
                //    location: {lat: 41.166020, lng: -8.626776},
                //}
            ],
            scheduled: [
                {
                    id: 56973509924,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4150-800 PORTO',
                    total: 44.6,
                    addressObs: "",
                    deliveryDate: moment(now).add(60, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 3 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509927,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4150-800 PORTO',
                    total: 44.6,
                    addressObs: "",
                    deliveryDate: moment(now).add(65, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 3 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509922,
                    customerName: "**TESTE**",
                    customerPhone: "222222222",
                    address: "Rua 5 de Outubro Second Part address",
                    city: "Porto",
                    total: 23.5,
                    postalCode: "4150-626 PORTO",
                    addressObs: "",
                    deliveryDate: moment(now).add(50, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 1 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509938,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4150-800 PORTO',
                    total: 44.6,
                    addressObs: "",
                    deliveryDate: moment(now).add(70, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 3 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509941,
                    customerName: 'DANIEL ANTAS',
                    customerPhone: '913081573',
                    address: 'Rua da Alegria',
                    city: 'PORTO',
                    postalCode: '4150-800 PORTO',
                    total: 44.6,
                    addressObs: "",
                    deliveryDate: moment(now).add(80, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 3 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },
                {
                    id: 56973509923,
                    customerName: 'DANIEL Martinho',
                    customerPhone: '913081573',
                    address: 'RUA CALOUSTE GULBENKIAN 17 5ºANDAR',
                    city: 'PORTO',
                    postalCode: '4050-145 PORTO',
                    total: 12.9,
                    addressObs: "",
                    deliveryDate: moment(now).add(55, 'm').toDate().toISOString(),
                    status: "CREATED",
                    dispatchStatus: "scheduled",
                    createdAt: moment(now - 2 * 60e3).toISOString(),
                    updatedAt: moment(now).toISOString(),
                },

            ]
        }), mockDelay)
    });


}


function getStoreInfo(storeId, params) {

    if (config.mock && config.mock === true) {
        console.debug("getStoreInfo: Using mock data")
        return getMock();
    }


    console.debug("Requesting data for store: " + storeId + "(" + JSON.stringify(params) + ")");

    return request.get(`${config.apiUrl}/v1/stores/${storeId}/info`)
        .withCredentials()
        .query(params)
        .set('Accept', 'application/json')
        .set(HEADER_STORE_CODE, storeId)
        .use(superagentPromisePlugin)
        .then(res => res.body)
        .catch(err => {
            console.error(err);
            throw err;
        });
}

function getOpenOrders(params) {

    const storeId = authUtils.getLoginStoreId();

    return request.get(`${config.apiUrl}/v1/stores/${params.storeId}/open-orders`)
        .withCredentials()
        .set('Accept', 'application/json')
        .set(HEADER_STORE_CODE, storeId)
        .use(superagentPromisePlugin)
        .then(res => res.body)
        .catch(err => {
            console.error(err);
            throw err;
        });
}

function closeDriverAlarm(alarm) {
    const storeId = authUtils.getLoginStoreId();

    return request.put(`${config.apiUrl}/v1/alarms/${alarm.id}/close`)
        .withCredentials()
        .set('Content-Type', 'application/json')
        .set(HEADER_STORE_CODE, storeId)
        .use(superagentPromisePlugin)
        .then(res => res.body)
        .catch(err => {
            console.error(err);
            throw err;
        });
}


function fastForwardScheduledOrder(orders) {


    // Make sure is its and array
    orders = (Array.isArray(orders) ? orders : [orders]);



    ServerActions.requestScheduledOrdersUpdate(orders);


    if (config.mock && config.mock === true) {
        getMock(4000).then(res => {
            console.log("Mock Response from server........")
            let updatedOrders = [];
            res.scheduled.forEach(order => {
                for (let i = 0; i < orders.length; ++i) {
                    if (orders[i] === order.id) {
                        let tmp = Object.assign({}, order);
                        tmp.dispatchStatus= "dispatched";
                        updatedOrders.push(tmp);
                    }
                }

            });

            console.log("-----> " + JSON.stringify(updatedOrders));
            ServerActions.updatedScheduledOrders(updatedOrders, orders);
        });

        return;
    }

    const storeId = authUtils.getLoginStoreId();

    return request.post(`${config.apiUrl}/v1/orders/scheduled/dispatch`)
        .withCredentials()
        .send(orders)
        .set('Accept', 'application/json')
        .set('Content-Type', 'application/json')
        .set(HEADER_STORE_CODE, storeId)
        .use(superagentPromisePlugin)
        .then(res => ServerActions.updatedScheduledOrders(res.body, orders))
        .catch(err => {
            ServerActions.updatedScheduledOrders(orders, orders)
            console.error(err);
            throw err;
        });
}


export default {
    getStoreInfo,
    getOpenOrders,
    closeDriverAlarm,
    fastForwardScheduledOrder,
};



// WEBPACK FOOTER //
// ./src/script/store.js